# marker aktuni pozice auta
my_position = 'start'

# s kazdou zmenou GPS probehne takhle akce, naplni se servisky
gps_success = (position) ->

  $('input[name=lat]').val position.coords.latitude
  $('input[name=lng]').val position.coords.longitude
  $('input[name=accurancy]').val position.coords.accuracy
  $('input[name=speed]').val position.coords.speed
  $('input[name=heading]').val position.coords.heading
  $('input[name=altitude]').val position.coords.altitude


  latLng = 
    lat: parseFloat(position.coords.latitude)
    lng: parseFloat(position.coords.longitude)


  return
gps_fail = (err) ->
  console.warn('ERROR(' + err.code + '): ' + err.message);
  return

pos = []
run_gps_tracker = ->
  console.log 'Tracker running ...'
  $('#restart_gps_watch').addClass 'hidden'
  options = 
    enableHighAccuracy: true,
    timeout: 10000,
    maximumAge: 1000

  pos = navigator.geolocation.watchPosition gps_success, gps_fail, options
  return



restart_gps_tracker = ->
  navigator.geolocation.clearWatch(pos)
  run_gps_tracker() 

distance = (lat1,lon1,lat2,lon2) -> 
  R = 6371
  dLat = (lat2-lat1) * Math.PI / 180
  dLon = (lon2-lon1) * Math.PI / 180
  a = Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(lat1 * Math.PI / 180 ) * Math.cos(lat2 * Math.PI / 180 ) *
    Math.sin(dLon/2) * Math.sin(dLon/2)
  c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  d = R * c;
  if d > 1
    return Math.round(d)
  else if d <= 1 
    return Math.round(d*1000)
  return d

# OBSOLETE ziska aktualni pozici na dotaz 
getGPS = ->

    dfd = new $.Deferred()

    pos = {}

    position = navigator.geolocation.getCurrentPosition(
        (position) ->
            pos =
              lat: position.coords.latitude
              lng: position.coords.longitude
              accurancy: position.coords.accuracy
              speed: position.coords.speed
              heading: position.coords.heading
              altitude: position.coords.altitude
            
            dfd.resolve(pos);
            return
        ->
            log 'GPS error'
            dfd.reject('GPS error');
            return
        , enableHighAccuracy: true
    )

    return dfd.promise();
    
saveGPS = ->
 
  if online()
    network = 'online'
  else
    network = 'offline'

  position =
      lat: $('input[name=lat]').val()
      lng: $('input[name=lng]').val()
      ride_hash: $('#ride_hash').val()
      taxametr_distance: $('#taxametr_servis').val()
      taxametr_price: $('#taxametr_price_servis').val()
      timer: $('#timer_servis').val()
      waiting: $('#waiting_servis').val()
      # cell_signal_type: $('#cell_signal_type').val()
      # cell_signal_downlink: $('#cell_signal_downlink').val()
      # cell_signal_rtt: $('#cell_signal_rtt').val()
      network: network
      accurancy: $('#accurancy').val()
      altitude: $('#altitude').val()
      speed: $('#speed').val()
      heading: $('#heading').val()

      date: getNowDateTimeStr()
      user: getUser()
      

  addToStack JSON.stringify(position)

  sendStack()

  # showOnMap($('input[name=lat]').val(), $('input[name=lng]').val())

  return